<template>
  <div class="box">
    <div class="box-body">
      <div class="row" v-if="$accessControl.isOperator($store.state.profile.profile)">
        <div class="col-md-3  col-md-offset-3 text-right">
          <strong>Setta valori a bobine selezionate:</strong>
        </div>
        <div class="col-md-2 text-right">

          <select v-model="massParam" class="form-control"
                  id="massParam"
                  name="massParam">
            <option value="digit">Digitalizzazione</option>
            <option value="restauro">Restauro</option>
            <option value="catalogato">Catalogato</option>
            <option value="web_enabled">Pubblicato archivio web</option>
          </select>
        </div>
        <div class="col-md-2 text-right">
          <select v-model="massValue" class="form-control"
                  id="massValue"
                  name="massValue">
            <option v-for="(desc, id) in ynp"
                    v-bind:value="id">
              {{ desc }}
            </option>
          </select>
        </div>
        <div class="col-md-2 text-right">
          <button class="btn btn-success btn-block"
                  v-on:click.prevent="saveMassParam"
                  :disabled="massParam === null || massValue === null || massSelected.length === 0">
            <i class="fa fa-circle-o-notch fa-spin" v-if="saveMassParamLoader"></i>
            Salva
          </button>
        </div>
      </div>
      <br/>
      <v-server-table url="" :columns="columns" :options="options" name="reels" ref="reels"
                      @row-click="showReel" @loading="toggleLoading" @loaded="toggleLoading">
        <template slot="id" slot-scope="props">
          <div>
            <input type="checkbox" :value="props.row.id" v-model="massSelected" v-on:click.stop=""/>
          </div>
        </template>
        <template slot="titolo_originale" slot-scope="props">
          <div style="width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
            {{ props.row.titolo_originale }}
          </div>
        </template>
        <template slot="titolo_attribuito" slot-scope="props">
          <div style="width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
            {{ props.row.titolo_attribuito }}
          </div>
        </template>
        <template slot="formato" slot-scope="props">
          <ul v-if="props.row.filmFormats">
            <li v-for="formato in props.row.filmFormats.data">
              {{ formato.name }}
            </li>
          </ul>
        </template>
        <template slot="cromatismo" slot-scope="props">
          <div v-if="props.row.description">
            {{ props.row.description.data.cromatismo | decodeValue('_dColor') }}
          </div>
        </template>
        <template slot="suono" slot-scope="props">
          <div v-if="props.row.description">
            {{ props.row.description.data.suono | decodeValue('_dYesNoPartial') }}
          </div>
        </template>
        <template slot="digit" slot-scope="props">
          <div class="text-center">
                                    <span class="label label-success" v-if="props.row.digit === 1">
                                        <span class="glyphicon glyphicon-ok"></span>
                                    </span>
            <span class="label label-warning" v-if="props.row.digit === 2">
                                        <span class="glyphicon glyphicon-ok"></span>
                                    </span>
            <span class="label label-danger" v-if="props.row.digit === 0 | props.row.digit === null">
                                        <span class="glyphicon glyphicon-remove"></span>
                                    </span>
          </div>
        </template>
        <template slot="durata" slot-scope="props">
          <div>
            {{ props.row.durata | secondsToTime }}
          </div>
        </template>
        <template slot="restauro" slot-scope="props">
          <div class="text-center">
                                    <span class="label label-success" v-if="props.row.restauro === 1">
                                        <span class="glyphicon glyphicon-ok"></span>
                                    </span>
            <span class="label label-warning" v-if="props.row.restauro === 2">
                                        <span class="glyphicon glyphicon-ok"></span>
                                    </span>
            <span class="label label-danger" v-if="props.row.restauro === 0 || props.row.restauro === null">
                                        <span class="glyphicon glyphicon-remove"></span>
                                    </span>
          </div>
        </template>
        <template slot="catalogato" slot-scope="props">
          <div class="text-center">
                                    <span class="label label-success" v-if="props.row.catalogato === 1">
                                        <span class="glyphicon glyphicon-ok"></span>
                                    </span>
            <span class="label label-danger" v-else-if="props.row.catalogato === 0">
                                        <span class="glyphicon glyphicon-remove"></span>
                                    </span>
            <span class="label label-warning"
                  v-else-if="props.row.catalogato === 2 | props.row.catalogato === null">
                                        <span class="glyphicon glyphicon-ok"></span>
                                    </span>
          </div>
        </template>
        <template slot="actions" slot-scope="props">
          <div>
            <button class="btn btn-danger btn-sm" v-on:click.stop="remove(props.row.id)"
                    v-if="$accessControl.isOperator($store.state.profile.profile)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </template>
      </v-server-table>
    </div>
    <div class="overlay" v-show="loading">
      <i class="fa fa-refresh fa-spin"></i>
    </div>
  </div>
</template>

<script>
import reelsApi from '../../api/reels'
import types from '../../store/mutation-types'
import reels from '@/api/reels'

export default {
  name: 'ReelsTab',
  props: {
    requestFunction: Function
  },
  data () {
    return {
      columns: [
        'id', 'identificativo', 'titolo_originale', 'titolo_attribuito', 'formato', 'cromatismo', 'suono', 'lunghezza', 'durata', 'digit', 'restauro', 'catalogato', 'actions'
      ],
      options: {
        saveState: false,
        headings: {
          'titolo_originale': 'Titolo proprio'
        },
        sortable: [
          'identificativo', 'titolo_originale', 'titolo_attribuito', 'formato', 'lunghezza', 'durata', 'digit', 'restauro', 'catalogato'
        ],
        requestFunction: this.$props.requestFunction,
        perPage: 200,
        orderBy: {
          column: 'identificativo',
          ascending: false
        }
      },
      loading: false,
      massSelected: [],
      massParam: null,
      massValue: null,
      saveMassParamLoader: false
    }
  },

  methods: {
    showReel (row) {
      this.$router.push({name: 'reelsShow', params: {id: row.row.id}})
      if (row.row.fund !== undefined) {
        this.$store.commit(types.SET_ACTUAL_FUND, _.cloneDeep(row.row.fund.data))
      }
    },
    refresh () {
      this.$refs.reels.refresh()
    },
    toggleLoading () {
      this.loading = !this.loading
    },
    remove (id) {
      if (confirm('Sei sicuro di procedere?')) {
        this.toggleLoading()
        reelsApi.delete(id)
          .then((response) => {
            this.toggleLoading()
            this.$refs.reels.refresh()
            toastr.success('La bobina è stata rimossa correttamente')
          })
          .catch((response) => {
            this.toggleLoading()
          })
      }
    },
    saveMassParam () {
      this.saveMassParamLoader = true
      return reels.updateMassive(this.massParam, this.massValue, this.massSelected)
        .then(() => {
          this.refresh()
        })
        .finally(() => {
          this.saveMassParamLoader = false
        })
    }
  },

  computed: {
    ynp () {
      if (this.massParam === 'web_enabled') {
        return this.$store.state.decoder.decoders['_dYesNo']
      } else {
        return this.$store.state.decoder.decoders['_dYesNoPartial']
      }
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/components/ReelsTab.vue